import * as React from "react";

export const AnnotationsDashboard = () => {
    return <div className="annotations">
        Not yet implemented
    </div>
}

